import { addToOverviewList } from './changesOverview'
import { updateDistriktFilter, updateKartlagFilter } from './filter'
import { byKey } from '../functions'
import { handleSessionTimeout } from '../login'
import { warn } from '../notifications'
import { rest } from '../server'
import { debug } from '../storage'
import { token } from '../tokens'

export let changes = [];
export const setChanges = (c) => changes = c;
export function getChanges() {
  return $.ajax({
    type: 'POST',
    url: rest + '/layers_new_updates_request' + token,
    data: JSON.stringify({ layergroup: 1 }),
    error: handleSessionTimeout,
    contentType: 'application/json',
    dataType: 'json'
  }).then(data => {
    // if (debug < 7) { console.log('Received JSON', data); }
    const c = data['layersNewUpdatesResLayers'];
    c.sort(byKey('id_after')).sort(byKeyWhenString('layer_id'));
    const distrikt = new Set();
    const kartlag = new Set();
    c.forEach((item, index) => {
      if (debug < 16) console.log(item, index);
      addToOverviewList(item, index + 1);
      distrikt.add(item.reinbeitebruker_id_before);
      kartlag.add(item.layer_name);
    });
    updateDistriktFilter(distrikt);
    updateKartlagFilter(kartlag);
    return c;
  });
}

export function acceptUpdate(rowIndex) {
  const i = rowIndex - 1;
  if (changes[i]) accept(changes[i]['id_after'], i);
}
function accept(id, i) {
  $.ajax({
    type: 'POST',
    url: rest + '/layer_accept_update_request' + token,
    data: JSON.stringify({ data_update_log_id_after: id, layergroup: 1 }),
    success: data => {
      // if (debug < 7) { console.log('Received JSON', data); }
      // Hide element from array, do not remove it to keep index order
      changes[i] = null;
      // Hide row from table, do not remove it to keep index order
      overviewBody.children[i].hidden = true;
    },
    error: e => { warn('Kunne ikke godkjennes'); handleSessionTimeout(e); },
    contentType: 'application/json',
    dataType: 'json'
  });
}

export function rejectUpdate(rowIndex) {
  const i = rowIndex - 1;
  if (changes[i]) reject(changes[i]['id_before'], i);
}
function reject(id, i) {
  $.ajax({
    type: 'POST',
    url: rest + '/layer_reject_update_request' + token,
    data: JSON.stringify({ data_update_log_id_before: id, layergroup: 1 }),
    success: data => {
      // if (debug < 7) { console.log('Received JSON', data); }
      // Show statsforvalter which distrikt made the change:
      console.log('Ta kontakt med brukeren:', changes[i].saksbehandler_after);
      // Hide element from array, do not remove it to keep index order
      changes[i] = null;
      // Hide row from table, do not remove it to keep index order
      overviewBody.children[i].hidden = true;
    },
    error: e => { warn('Kunne ikke avvises'); handleSessionTimeout(e); },
    contentType: 'application/json',
    dataType: 'json'
  });
}

// To sort an array of obj by obj.key, in case key value is a string
function byKeyWhenString(k) {
  return function (a, b) {
    return ((a[k] === b[k]) ? 0 : ((a[k] > b[k]) ? 1 : -1));
    // return a[k] > b[k];
  };
};
